import { VOZIDLO_DATA_TYPE } from '@/modules/kartoteka/vozidlo/constants';

export { DMS_MODULE } from '../../constants';

export const NAME = VOZIDLO_DATA_TYPE.ZAVADA;
export const API_NAME = 'OdlozenaServisniCinnost';
export const CRUMB_LABEL_KEY = 'edtVozZavada';
